import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import { ViewController } from 'ionic-angular';
import config from '../../config/config';
/**
 * Generated class for the ModalEventoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modal-evento',
  templateUrl: 'modal-evento.html',
})
export class ModalEventoPage {
  usuario = null;
  form = {};
  constructor(
    public navCtrl: NavController,
    private alertCtrl: AlertController,
     public navParams: NavParams,
     public viewCtrl: ViewController,
     public loadingCtrl: LoadingController,
  	private _http : Http,
     ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get('usuario');

    console.log(this.usuario);
  }
  Cadastro(form){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    form.usuario_id = this.usuario.id;
    form.aberto = 1;

    this._http
    .post(config.urlAPI+"evento/Cadastro",form,{})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss();
      let alert = this.alertCtrl.create({
        title: "Evento",
        message:
          "Seu evento foi cadastrado com sucesso.",
        buttons: [
          {
            text: "OK",
            handler: () => {
              this.viewCtrl.dismiss();

            }
          }
        ],
        enableBackdropDismiss: false
      });
      alert.present();

       }).catch(error => {
      loading.dismiss();

     
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal-evento/modal-evento.ts